import { t } from '../../lang';
import HelperService from '../../services/HelperService';
import Icon, { Icons } from '../Icon/Icon';
import './DeviceItem.scss';

const DeviceItem = ({
	device,
	isCurrent = false,
	showTerminateAll = false,
	bottomSeparator = false,
	deleteDevice,
	terminateAll,
}) => {
	return (
		<div className={`DeviceItem ${isCurrent ? 'current' : ''}`}>
			<div className='DeviceItem__info'>
				<div className='DeviceItem__info-icon'>
					<Icon type={device?.DeviceType === 1 ? Icons.MOBILE : Icons.LAPTOP} width={32} height={32} />
				</div>
				<div className={`DeviceItem__info-content ${bottomSeparator ? 'bottom-separator' : ''}`}>
					<div className='DeviceItem__info-text'>
						<div className='DeviceItem__info-name'>{device?.Name}</div>
						<div className='DeviceItem__info-status'>
							{isCurrent ? t('Online') : HelperService.formatLastOnline(device?.LastActivity)}
						</div>
					</div>
					{!isCurrent && (
						<div className='DeviceItem__info-action' onClick={() => deleteDevice([device.Id])}>
							<Icon type={Icons.TRASH} width={24} height={24} />
						</div>
					)}
				</div>
			</div>

			{isCurrent && showTerminateAll && (
				<div className='DeviceItem__terminate' onClick={terminateAll}>
					<Icon type={Icons.HAND} width={28} height={28} />
					<span className='DeviceItem__terminate-text'>{t('Terminate all other sessions')} </span>
				</div>
			)}
		</div>
	);
};

export default DeviceItem;
